"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .config(function ($stateProvider, $urlRouterProvider) {
    $stateProvider.state("main.disapprovalreason", {
      url: "disapprovalreason",
      resolve: {
        list: [
          "$stateParams",
          "DisapprovalReason",
          function ($stateParams, DisapprovalReason) {
            return DisapprovalReason.list().$promise;
          },
        ],
      },
      views: {
        main: {
          templateUrl:
            "/modules/Commom/disapprovalreason/views/disapprovalreason.list.html",
          controller: "disapprovalreasonListCtrl",
          controllerAs: "vm",
        },
      },
    });

    $stateProvider.state("main.disapprovalreason-edit", {
      url: "disapprovalreason/:id",
      resolve: {
        model: [
          "$stateParams",
          "DisapprovalReason",
          function ($stateParams, DisapprovalReason) {
            if ($stateParams.id) {
              return DisapprovalReason.get({ id: $stateParams.id }).$promise;
            }

            return {};
          },
        ],
      },
      views: {
        main: {
          templateUrl:
            "/modules/Commom/disapprovalreason/views/disapprovalreason.edit.html",
          controller: "disapprovalreasonEditCtrl",
          controllerAs: "vm",
        },
      },
    });
  });
